import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { SOAP_KEYS } from "@/lib/soap";
import { copyText } from "@/lib/clipboard";

export function SoapSections({ values, onChange, streaming }) {
  return (
    <div className="space-y-4">
      {SOAP_KEYS.map((s) => (
        <div key={s.key} className="rounded-xl border bg-white overflow-hidden focus-within:border-primary/50 transition-colors">
          <div className="flex items-center gap-3 border-b bg-secondary/50 px-4 py-2.5">
            <span className="h-7 w-7 rounded-md bg-primary text-white grid place-items-center font-display font-bold text-sm">{s.letter}</span>
          <div className="flex-1">
              <div className="text-sm font-semibold text-slate-900">{s.label}</div>
              <div className="text-[11px] text-slate-500">{s.hint}</div>
            </div>
            <Button type="button" variant="ghost" size="sm" className="h-7 text-slate-500 hover:text-primary" disabled={streaming || !values[s.key]}
              onClick={() => copyText(values[s.key], `${s.label} copied`)} data-testid={`soap-${s.key}-copy-button`}>
              <Copy className="h-3.5 w-3.5 mr-1" />Copy
            </Button>
          </div>
          <Textarea
            value={values[s.key] || ""}
            onChange={(e) => onChange(s.key, e.target.value)}
            readOnly={streaming}
            placeholder={streaming ? "Writing…" : `${s.label} will appear here — or type it yourself.`}
            className="min-h-[120px] border-0 rounded-none focus-visible:ring-0 text-[15px] leading-relaxed resize-y"
            data-testid={`soap-${s.key}-textarea`}
          />
        </div>
      ))}
    </div>
  );
}
